import { api, currentCreche, currentOrganization } from '../api'

const RegistrationRepository = {
    index (query = null) {
        return api().$get(`/${currentCreche().uuid}/registrations`, query)
    },

    allBalances () {
        return api().$get(`/${currentCreche().uuid}/registrations/billing-balance`)
    },

    exportAllBalances () {
        return api().$post(`/${currentCreche().uuid}/registrations/billing-balance/export`, {}, { download: true })
    },

    show (uuid) {
        return api().$get(`/${currentCreche().uuid}/registrations/${uuid}`)
    },

    create (payload) {
        return api().$post(`/${currentCreche().uuid}/registrations`, payload)
    },

    update (uuid, payload, crecheUuid = null) {
        return api().$put(`/${crecheUuid || currentCreche().uuid}/registrations/${uuid}`, payload)
    },

    updateBulkStatus (payload, crecheUuid = null) {
        return api().$patch(`/${crecheUuid || currentCreche().uuid}/registrations/bulk/update-status`, payload)
    },

    delete (uuid, crecheUuid = null) {
        return api().$delete(`/${crecheUuid || currentCreche().uuid}/registrations/${uuid}`)
    },

    forceDelete (uuid, crecheUuid = null) {
        return api().$delete(`/${crecheUuid || currentCreche().uuid}/registrations/${uuid}`, { force: true })
    },

    restore (uuid) {
        return api().$post(`/${currentCreche().uuid}/registrations/${uuid}/restore`)
    },

    getLogs (uuid, query = {}) {
        return api().$get(`/${currentCreche().uuid}/registrations/${uuid}/activity-logs`, query)
    },

    exportLogs (uuid, query = {}) {
        return api().$get(`/${currentCreche().uuid}/registrations/${uuid}/activity-logs/export`, query, { download: true })
    },

    quota (uuid, query = {}, crecheUuid = null) {
        return api().$get(`/${crecheUuid || currentCreche().uuid}/registrations/${uuid}/quota`, query)
    },

    multipleQuota (query = {}, crecheUuid = null) {
        return api().$get(`/${crecheUuid || currentCreche().uuid}/registrations/quota`, query)
    },

    balance (uuid) {
        return api().$get(`/${currentCreche().uuid}/registrations/${uuid}/billing-balance`)
    },

    invoiceDeposit (registrationUuid) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/invoice-deposit`)
    },

    creditNoteDepositRefund (registrationUuid) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/credit-note-deposit-refund`)
    },

    downloadFiscalDocument (registrationUuid, payload) {
        return api().$get(`/${currentCreche().uuid}/registrations/${registrationUuid}/fiscal-document`, payload, {
            responseType: 'blob'
        })
    },

    export (payload) {
        return api().$post(`/${currentCreche().uuid}/registrations/export`, payload, { responseType: 'blob' })
    },

    exportRemunerations (payload) {
        return api().$post(`/${currentCreche().uuid}/registrations/remunerations/export`, payload, { responseType: 'blob' })
    },

    exportRemunerationsByFilters (payload) {
        return api().$post(`/${currentCreche().uuid}/registrations/remunerations/export-by-filter`, payload, { responseType: 'blob' })
    },

    exportQrCodes (registrationUuids) {
        return api().$post(`/${currentCreche().uuid}/registrations/qr-codes`, { registration_uuids: registrationUuids }, { responseType: 'blob' })
    },

    acceptWaitingListNotification (registrationUuid) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/waiting-list/accept`)
    },

    listPreDemandesOne () {
        return api().$get(`/${currentCreche().uuid}/registrations/fetch-one-pre-demandes`)
    },

    getPreDemandeOne (numeroPreDemande, crecheUuid = null) {
        return api().$get(`/${crecheUuid || currentCreche().uuid}/registrations/fetch-one-pre-demandes/${numeroPreDemande}`)
    },

    sendSmsAlert (registrationUuid) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/sms/alert-absence`)
    },

    clone (registrationUuid, payload = {}) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/clone`, payload)
    },

    calculateYearlyQuota (registrationUuid, payload = {}) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/one/absence-quota`, payload)
    },

    sendPaymentInvitationNotification  (registrationUuid, payload = {}) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/send-payment-invitation`, payload)
    }
}

export default RegistrationRepository
